import React, { useRef, useState, useEffect } from 'react';
import { BookmarkStar, ExclamationCircleFill } from 'react-bootstrap-icons';
import Logo from "../../assets/Common/Logo.png";
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import ArrowNew from "../../assets/Common/send.png"
import { useDispatch, useSelector } from 'react-redux';
import flags from "react-phone-number-input/flags";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import useMicroSiteEncrypt from '../CustomHook/useMicroSiteEncrypt';
import { submitLeadForm, urlUpdateHandle } from '../../redux/actions/micrositeAction';
import RecaptchaComponent from '../commonSection/RecaptchaComponent';

export default function CategoryDetails({ detail, colors }) {
    const dispatch = useDispatch();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [nameError, setNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [recaptchaToken, setRecaptchaToken] = useState("");
    const [imageLoaded, setImageLoaded] = useState(false);
    const { microSiteEncrypt, token, error } = useMicroSiteEncrypt();
    const current_flow = useSelector((state) => state.microsite?.home_data?.flow);
    const url_data = useSelector((state) => state.microsite?.url_data);
    const customize_fields = useSelector(
        (state) => state.microsite?.home_data?.customization
    );
    
    // Ensure URL is set when component mounts
    useEffect(() => {
        if (!url_data) {
            const currentUrl = window?.location?.href || "";
            dispatch(urlUpdateHandle(currentUrl));
        }
    }, [url_data, dispatch]);
    const submitForm = () => {
        if (name == "" && customize_fields?.top_contact?.name?.validation == "required") {
            setNameError(true);
            return;
        } else if ((mobile == "" || mobileError == true) && customize_fields?.top_contact?.phone?.validation == "required") {
            setMobileError(true);
            return;
        } else if ((email == "" && customize_fields?.top_contact?.email?.validation == "required") || emailError == true) {
            setEmailError(true);
            return;
        } else {
            setNameError(false);
            setMobileError(false);
            setEmailError(false);
        }
        // Get current URL - prioritize current window URL over Redux store
        const currentUrl = window?.location?.href || url_data || "";
        console.log("Current URL", currentUrl);
        console.log("Redux URL", url_data);
        console.log("Window URL", window?.location?.href);
        let payload = {
            fullname: name,
            phoneNo: mobile,
            emailId: email,
            recaptcha_token: recaptchaToken,
            url: currentUrl
        }
        const generateToken = async () => {
        const token = await microSiteEncrypt();
            if (token && token !== "") {
                dispatch(submitLeadForm(token ,payload, "Category Form", current_flow, onSuccess))
            }
        };
        
        generateToken();
    }    
    
    const onSuccess = () => {
        setName("");
        setEmail("");
        setMobile("");
    }
    
    return (
        <>
            <div style={{ backgroundColor: `${colors?.primary}10` }} className='flex w-full max-sm:block items-center gap-4 max-sm:rounded-[20px] rounded-b-[20px] lg:max-w-7xl mx-auto'>
                <div className='w-2/3 max-sm:w-full text-left space-y-4 max-sm:space-y-2 p-14 max-sm:p-4'>
                    <img 
                        src={detail?.icon && imageLoaded ? detail?.icon : "https://salespanda.com/client/pdf/categories_default_image.png"} 
                        className='w-12' 
                        alt="logo"
                        onLoad={() => {
                            if (detail?.icon) {
                                setImageLoaded(true);
                            }
                        }}
                        onError={(e) => {
                            e.target.src = "https://salespanda.com/client/pdf/categories_default_image.png";
                            setImageLoaded(false);
                        }}
                    />
                    <h1 className='text-black text-[64px] max-sm:text-3xl not-italic font-semibold leading-[110%]'>{detail?.title != "" ? detail?.title : ""}</h1>
                    {/* <div className='flex gap-4'>
                        <span className="inline-flex bg-[#fff] gap-1 rounded-full text-[#2167A7] text-xs not-italic font-medium leading-4 items-center px-2 py-1 ring-1 ring-inset ring-[#2167A7]">
                            <BookmarkStar />
                            15 year ex
                        </span>
                        <span className="inline-flex bg-[#fff] gap-1 rounded-full text-[#2167A7] text-xs not-italic font-medium leading-4 items-center px-2 py-1 ring-1 ring-inset ring-[#2167A7]">
                            <BookmarkStar />
                            Top Employee
                        </span>
                        <span className="inline-flex bg-[#fff] gap-1 rounded-full text-[#2167A7] text-xs not-italic font-medium leading-4 items-center px-2 py-1 ring-1 ring-inset ring-[#2167A7]">
                            <BookmarkStar />
                            Insurance Expert
                        </span>
                    </div> */}
                    <p style={{color: colors.textMuted}} className='text-base not-italic font-normal leading-[132%]'>
                        {detail?.description}
                    </p>
                </div>
                <div className='w-1/3 max-sm:w-full p-4'>
                    <div style={{backgroundColor: colors.primary}} className='p-6 space-y-6 rounded-3xl max-sm:rounded-2xl'>
                        <div className='space-y-6'>
                            <div>
                                <div className='relative'>
                                    <input
                                        placeholder={`Your Name? ${customize_fields?.top_contact?.name?.validation == "required" ? "*":""}`}
                                        id="first-name"
                                        name="first-name"
                                        type="text"
                                        autoComplete="given-name"
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset custom_ring_color sm:text-sm sm:leading-6"
                                        value={name}
                                        onChange={(e) => {  
                                            const regex = /^[a-zA-Z ]*$/;
                                            if (regex.test(e.target.value)) {
                                                setName(e.target.value);
                                            }  
                                            if (e.target.value != "") {
                                                setNameError(false);
                                            }
                                        }}
                                    />
                                    {nameError != false && <ExclamationCircleFill title="Enter a name" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <div className="relative country-customize mt-2.5">
                                    <PhoneInput
                                        flags={flags}
                                        placeholder=""
                                        value={mobile}
                                        defaultCountry="IN"
                                        limitMaxLength
                                        countryCallingCodeEditable={false}
                                        international={true}                            
                                        onChange={(e) => {
                                        if (e) {
                                            setMobile(e)
                                            if (isValidPhoneNumber(e)) {
                                                setMobileError(false); 
                                            } else {
                                                setMobileError(true); 
                                            }
                                        } else {
                                            setMobile("");
                                            setMobileError(false); 
                                        }
                                        }}
                                    />
                                    {mobileError != false && <ExclamationCircleFill title="Enter a valid mobile number" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <div className="mt-2.5 relative">
                                    <input
                                        placeholder={`Email ID ${customize_fields?.top_contact?.email?.validation == "required" ? " *":""}`}
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset custom_ring_color sm:text-sm sm:leading-6"
                                        value={email}
                                        onChange={(e) => {
                                            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;                       
                                            if (regex.test(e.target.value) || e.target.value == "") {
                                                setEmailError(false);
                                            } else {
                                                setEmailError(true);
                                            }   
                                            setEmail(e.target.value)
                                        }}
                                    />
                                    {emailError != false && <ExclamationCircleFill title="Enter a valid email" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                                </div>
                            </div>  
                            <RecaptchaComponent onVerify={setRecaptchaToken} />                            
                        </div>
                        <div className='w-full flex justify-end'>
                            <span onClick={submitForm} 
                                  style={{backgroundColor: colors.secondary,borderColor: colors.secondary}} 
                                  className="inline-flex cursor-pointer border text-[#fff] my-auto py-1.5 px-4 text-sm not-italic font-semibold shadow-sm rounded-[49px] gap-2">
                                Let's Discuss
                                <img src={ArrowNew} alt='arrow' />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

